<template>
    <div>
        <br>
        <br>
        <br>
        <h1>RX NEUMOLOGICO</h1>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default{
    name: 'c-asistencial-sop-historia-rxneumologico',
    data() {
        return {
            //property: 'value',
        };
    },
    methods: {
        ...mapActions(['get', 'post']),
    },
}
</script>